import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CategoriesMenuModule} from './categories-menu/categories-menu.module';
import {CountrySelectorModule} from './country-selector/country-selector.module';
import {DynamicHeadingModule} from './dynamic-heading/dynamic-heading.module';
import {HelpIconModule} from './help-icon/help-icon.module';
import {IframeCloseIconModule} from './iframe-close-icon/iframe-close-icon.module';
import {ReturnToModule} from './return-to/return-to.module';
import {SapLogoModule} from './sap-logo/sap-logo.module';
import {SecureIconModule} from './secure-icon/secure-icon.module';
import {UserMenuModule} from './user-menu/user-menu.module';
import {DcpMiniCartModule} from './mini-cart/dcp-mini-cart.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CategoriesMenuModule,
    CountrySelectorModule,
    DynamicHeadingModule,
    HelpIconModule,
    IframeCloseIconModule,
    DcpMiniCartModule,
    ReturnToModule,
    SapLogoModule,
    SecureIconModule,
    UserMenuModule
  ],
  exports: [
    CategoriesMenuModule,
    CountrySelectorModule,
    DynamicHeadingModule,
    HelpIconModule,
    IframeCloseIconModule,
    DcpMiniCartModule,
    ReturnToModule,
    SapLogoModule,
    SecureIconModule,
    UserMenuModule
  ]
})
export class HeaderModule {
}
